import { addIcon } from '@iconify/react';

// Importar colecciones de iconos completas (usar CJS index.js en lugar de .mjs)
import fa6Solid from '@iconify-json/fa6-solid/index.js';
import fa6Regular from '@iconify-json/fa6-regular/index.js';
import faBrands from '@iconify-json/fa-brands/index.js';
import icIconsCollection from '@iconify-json/ic/index.js';
import fluentIconsCollection from '@iconify-json/fluent/index.js';
import biIconsCollection from '@iconify-json/bi/index.js';

// Extraer mapas de iconos
const { icons: solidIcons } = fa6Solid;
const { icons: regularIcons } = fa6Regular;
const { icons: brandIcons } = faBrands;
const { icons: icIcons } = icIconsCollection;
const { icons: fluentIcons } = fluentIconsCollection;
const { icons: biIcons } = biIconsCollection;

// Registrar todos los iconos
addIcon('fa6-solid:circle-check', solidIcons['circle-check']);
addIcon('fa6-solid:arrows-up-down-left-right', solidIcons['arrows-up-down-left-right']);
addIcon('fa6-solid:clock', solidIcons['clock']);
addIcon('fa6-solid:calendar-days', solidIcons['calendar-days']);
addIcon('fa6-solid:star', solidIcons['star']);

addIcon('fa6-regular:clock', regularIcons['clock']);
addIcon('fa6-regular:star', regularIcons['star']);

addIcon('fa-brands:facebook-f', brandIcons['facebook-f']);
addIcon('fa-brands:linkedin-in', brandIcons['linkedin-in']);
addIcon('fa-brands:youtube', brandIcons['youtube']);
addIcon('fa-brands:twitter', brandIcons['twitter']);
addIcon('fa-brands:instagram', brandIcons['instagram']);

addIcon('ic:baseline-whatsapp', icIcons['baseline-whatsapp']);
addIcon('fluent:call-24-regular', fluentIcons['call-24-regular']);
addIcon('bi:envelope', biIcons['envelope']);
